// extracted by mini-css-extract-plugin
export default {"fullContainer":"WishlistCard_fullContainer__lXdax"};